import React from 'react';
import { BonusBlock } from '../BonusBlock';
import { SectionCTA } from '../SectionCTA';
import { bonuses } from '../../data/bonuses';
export function Bonuses() {
  return <section className="bg-white px-5 py-16 md:py-24" aria-labelledby="bonuses-title" data-id="element-133" data-mp="1cl63bbuufoi4">
      <div className="mx-auto max-w-6xl" data-id="element-134" data-mp="1citlcyp35e52">
        <p className="text-center font-display text-xs font-extrabold uppercase tracking-[0.14em] text-pulse sm:text-sm" data-id="element-135" data-mp="18kdv8lxpjpnf">
          Exclusive bonuses — included with your purchase
        </p>
        <h2 id="bonuses-title" className="mx-auto mt-3 max-w-4xl text-center font-display text-3xl font-black leading-tight text-navy-900 sm:text-5xl text-balance" data-id="element-136" data-mp="20aikoz0br2vi">
          Today, You’ll Also Receive These 5 Specialized ECG Learning Resources
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-center text-lg text-muted" data-id="element-137" data-mp="ktqfjehjvvqb">
          Five complementary resources to help you review essential concepts, practice rhythm recognition, and organize
          your ECG studies.
        </p>

        <div className="mt-12 space-y-16 md:space-y-24" data-id="element-138" data-mp="1euybvz40a39o">
          {bonuses.map((bonus, index) => <BonusBlock key={bonus.number} bonus={bonus} reversed={index % 2 === 1} data-id="element-139" data-mp="1js81bereaexi" data-mpi={index} />)}
        </div>

        <SectionCTA label="Yes! I want all 5 ECG bonuses included" note="All five bonuses are included with your $27 purchase" data-id="element-140" data-mp="15sp7zs38t859" />
      </div>
    </section>;
}